$R.addLang('fr', {
    'words': 'mots',
    'chars': 'caractères'
});